import React from "react";
import { inject, observer } from "mobx-react";
import Store from "../../stores/NewExistingOwnerStore";
import { PageViews, UserStatus } from "../../models/NewExistingOwner";
import { Disclaimer } from "./";

interface IProps {
  store?: Store;
}

interface IState {}

@inject("store")
@observer
class Intro extends React.Component<IProps, IState> {
  state: IState = {};

  get store(): Store {
    return this.props.store;
  }

  render() {
    return (
      <section className="pageSection__content text-center">
        <div className="container">
          <div className="row">
            <div className={this.store.innerWidthClassNames}>
              <h1 className="h1">Subaru owner</h1>
              <p>
                If you have recently purchased a new Subaru Vehicle, your purchasing Subaru Retailer has already let us
                know you're the owner so there's no need to fill this form out.
              </p>
              <p>&nbsp;</p>

              <div className="neo__orGroup">
                <div className="neo__orOpt">
                  <p className="neo__statusOptIntro">
                    If you have recently purchased a used Subaru, you can let us know your contact information here.
                  </p>
                  <div className="neo__statusOpt">
                    <h3 className="h3">Register my Subaru</h3>
                    <button
                      className="btn btn--primary"
                      onClick={() => {
                        this.store.userStatus = UserStatus.New;
                        this.store.activePage = PageViews.FindCar;
                      }}
                    >
                      Register
                    </button>
                  </div>
                </div>

                <div className="neo__orSep neo__orSep--statusOpt" />

                <div className="neo__orOpt">
                  <p className="neo__statusOptIntro">
                    If you have purchased a new Subaru from us previously, you can update your details here.
                  </p>
                  <div className="neo__statusOpt">
                    <h3 className="h3">Update my details</h3>
                    <button
                      className="btn btn--primary"
                      onClick={() => {
                        this.store.userStatus = UserStatus.Existing;
                        this.store.activePage = PageViews.FindCar;
                      }}
                    >
                      Update details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Disclaimer />
        </div>
      </section>
    );
  }
}

export default Intro;
